import React from 'react';
import PageHero from './PageHero';
import ibPypLogo from '../assets/ib-pyp.png';
import ibMypLogo from '../assets/ib-myp.png';
import ibDpLogo from '../assets/ib-dp.png';
import ibCpLogo from '../assets/ib-cp.png';
import cambridgeLogo from '../assets/CAMBRIDGE.png';
import bseisiLogo from '../assets/BSEISI.png';
import heroImg from '../assets/Banner-GMIS Students.png';

export default function AccreditationLicensesPage({ setPage, t }) {
  const navCategory = t?.nav?.[1]?.label || "About Us";
  const homeLabel = t?.nav?.[0]?.label || "Home";

  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen text-ink">
      {/* ── Page Hero ──────────────────────────────────────────────────────── */}
      <PageHero
        title="Accreditation & Licenses"
        eyebrow={navCategory}
        subtitle="Global authorisations and recognized credentials that define our academic excellence and heritage since 1950."
        breadcrumbs={[homeLabel, navCategory, 'Accreditation & Licenses']}
        bgImage={heroImg}
      />

      {/* ── Main Content Container ────────────────────────────────────────── */}
      <div className="max-w-[1200px] mx-auto px-6 lg:px-[80px] py-16 lg:py-24 box-border">

        {/* ── Section 1: Official Licences (Matching Reference Image 1) ──────── */}
        <div className="bg-white rounded-2xl p-8 sm:p-10 lg:p-12 border border-line shadow-sm mb-16 lg:mb-20">
          <div className="mb-6">
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-navy tracking-tight uppercase">
              Official Licences
            </h2>
            <div className="w-12 h-1 bg-gold mt-2" />
          </div>

          <ul className="space-y-4 text-[15px] sm:text-[16px] text-ink/85 leading-relaxed list-disc pl-5">
            <li>
              <span className="font-semibold text-navy">Oldest License for Primary, Middle &amp; Senior School:</span> No. 014/0/1978
            </li>
            <li>
              <span className="font-semibold text-navy">Oldest License for Pre-Primary School:</span> B-41/TP-PAPPA/II/78
            </li>
            <li>
              <span className="font-semibold text-navy">SPK Licenses:</span> 272/MPK.B1/DU/2014 (TK), 310/MPK.D/KL/2016 (SD), 311/MPK.D/KL/2016 (SMP), 312/MPK.D/KL/2016 (SMA)
            </li>
          </ul>
        </div>

        {/* ── Section 2: Accreditations & Authorizations (Matching Reference Image 2) ─── */}
        <div className="mb-20 lg:mb-24">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-navy tracking-tight uppercase">
              Accreditations &amp; Authorizations
            </h2>
            <div className="w-14 h-1 bg-gold mx-auto mt-4" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {/* Card 1: IB Primary Years Programme */}
            <div className="bg-white rounded-2xl p-8 border border-line shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center group">
              <div className="h-16 w-full flex items-center justify-center mb-5">
                <img
                  src={ibPypLogo}
                  alt="IB Primary Years Programme"
                  className="max-h-12 max-w-[200px] object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-heading font-bold text-[18px] sm:text-[19px] text-navy mb-3 leading-snug">
                IB Primary Years Programme
              </h3>
              <p className="text-[14px] text-ink/75 leading-relaxed m-0">
                Authorized IB World School offering PYP to nurture inquiry-driven young learners.
              </p>
            </div>

            {/* Card 2: IB Middle Years Programme */}
            <div className="bg-white rounded-2xl p-8 border border-line shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center group">
              <div className="h-16 w-full flex items-center justify-center mb-5">
                <img
                  src={ibMypLogo}
                  alt="IB Middle Years Programme"
                  className="max-h-12 max-w-[200px] object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-heading font-bold text-[18px] sm:text-[19px] text-navy mb-3 leading-snug">
                IB Middle Years Programme
              </h3>
              <p className="text-[14px] text-ink/75 leading-relaxed m-0">
                IB MYP empowers students to become creative, critical, and reflective thinkers.
              </p>
            </div>

            {/* Card 3: IB Diploma Programme */}
            <div className="bg-white rounded-2xl p-8 border border-line shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center group">
              <div className="h-16 w-full flex items-center justify-center mb-5">
                <img
                  src={ibDpLogo}
                  alt="IB Diploma Programme"
                  className="max-h-12 max-w-[200px] object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-heading font-bold text-[18px] sm:text-[19px] text-navy mb-3 leading-snug">
                IB Diploma Programme
              </h3>
              <p className="text-[14px] text-ink/75 leading-relaxed m-0">
                The internationally respected IB Diploma curriculum for rigor and breadth.
              </p>
            </div>

            {/* Card 4: IB Career-Related Programme */}
            <div className="bg-white rounded-2xl p-8 border border-line shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center group">
              <div className="h-16 w-full flex items-center justify-center mb-5">
                <img
                  src={ibCpLogo}
                  alt="IB Career-Related Programme"
                  className="max-h-12 max-w-[200px] object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-heading font-bold text-[18px] sm:text-[19px] text-navy mb-3 leading-snug">
                IB Career-Related Programme
              </h3>
              <p className="text-[14px] text-ink/75 leading-relaxed m-0">
                Integrates academic study with career-focused learning, preparing students for future success.
              </p>
            </div>

            {/* Card 5: Cambridge International */}
            <div className="bg-white rounded-2xl p-8 border border-line shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center group">
              <div className="h-16 w-full flex items-center justify-center mb-5">
                <img
                  src={cambridgeLogo}
                  alt="Cambridge International"
                  className="max-h-12 max-w-[180px] object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-heading font-bold text-[18px] sm:text-[19px] text-navy mb-3 leading-snug">
                Cambridge International
              </h3>
              <p className="text-[14px] text-ink/75 leading-relaxed m-0">
                Authorized Cambridge Examination Centre — Checkpoints &amp; IGCSE stream.
              </p>
            </div>

            {/* Card 6: BSEISI */}
            <div className="bg-white rounded-2xl p-8 border border-line shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center group">
              <div className="h-16 w-full flex items-center justify-center mb-5">
                <img
                  src={bseisiLogo}
                  alt="BSEISI"
                  className="max-h-14 max-w-[85px] object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-heading font-bold text-[18px] sm:text-[19px] text-navy mb-3 leading-snug">
                BSEISI
              </h3>
              <p className="text-[14px] text-ink/75 leading-relaxed m-0">
                Affiliated with Board of Secondary Education Indian Schools Indonesia and recognized by Association of Indian University.
              </p>
            </div>
          </div>
        </div>

        {/* ── Section 3: Call to Action Strip (Unified Theme) ───────────────── */}
        <div className="w-full bg-navy rounded-3xl p-10 md:p-14 text-center text-white shadow-xl relative overflow-hidden">
          <div className="w-16 h-1 bg-gold mx-auto mb-6" />
          <h3 className="font-heading font-bold text-2xl sm:text-3xl md:text-4xl leading-snug max-w-3xl mx-auto tracking-tight mb-4 uppercase">
            Join a School with Global Recognition
          </h3>
          <p className="text-white/75 text-[15.5px] max-w-2xl mx-auto mb-8 leading-relaxed">
            Explore our world-recognized academic programmes or connect directly with our admissions team to discover the ideal pathway for your child.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={() => {
                if (setPage) setPage('admissions-process');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="px-8 py-3.5 rounded-lg bg-gold text-navy font-heading font-bold text-xs uppercase tracking-widest hover:bg-gold/90 transition-all shadow-md cursor-pointer"
            >
              Apply Now
            </button>
            <button
              onClick={() => {
                if (setPage) setPage('schedule-visit');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="px-8 py-3.5 rounded-lg bg-white/10 text-white font-heading font-bold text-xs uppercase tracking-widest hover:bg-white/20 transition-all border border-white/20 cursor-pointer"
            >
              Schedule a Visit
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
